/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_One_KkInputs */

const cs_enum_one_kk = /** @type {(inputs: Enum_One_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1+kk`)
};

const en_enum_one_kk = /** @type {(inputs: Enum_One_KkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1+kk`)
};

/**
* | output |
* | --- |
* | "1+kk" |
*
* @param {Enum_One_KkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_one_kk = /** @type {((inputs?: Enum_One_KkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_One_KkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_one_kk(inputs)
	return cs_enum_one_kk(inputs)
});